<template>
  <div>
    <div>
      <div class="form-actions flex justify-between">
        <div class="float-right flex">
          <vx-tooltip text="View all CNIC Promos" position="top">
            <vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" icon="icon-external-link" @click="viewAllCNICPromos()"></vs-button>
          </vx-tooltip>
        </div>
      </div>

      <div class="dashboard-scrollable-area">
        <div id="grid-loader" class="vx-card vs-con-loading__container">
          <ag-grid-vue
            id="autoHeightGrid"
            :gridOptions="gridOptions"
            class="ag-theme-material w-100 ag-grid-table"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            :components="components"
            :rowData="tableData"
            rowSelection="multiple"
            :enableRangeSelection="true"
            :suppressCopyRowsToClipboard="true"
            :suppressDragLeaveHidesColumns="true"
            :animateRows="false"
            :floatingFilter="true"
            :pagination="false"
            :suppressRowClickSelection="true"
            :statusBar="statusBar"
            :sideBar="sideBar"
            :rowHeight="30"
            :headerHeight="30"
            :floatingFiltersHeight="35"
            :checkboxSelection="true"
            :domLayout="domLayout"
            @column-resized="onColumnResized">
          </ag-grid-vue>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue';
import 'ag-grid-enterprise';
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import '@/assets/scss/radix/extraComponents/agGridStyleOverride.scss';

import CellRendererAgreementList from '@/components/ag-grid-tables/actions/CellRendererAgreementList.vue';

import EditCnicPromo from '@/components/ag-grid-tables/promos/EditCNICPromo.vue';

export default {
  name: 'CNICPromoDashboardComponent',
  components: {
    AgGridVue,
    CellRendererAgreementList,
    EditCnicPromo,
  },
  props: {
    filteredData: {
      type: Array,
      default: null,
    },
    activeFilterStatus: {
      type: String
    }
  },
  data() {
    return {
      selectedRowCount: '',
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        suppressMovable: false,
        filterParams: {
          suppressAndOrCondition: true,
          newRowsAction: 'keep',
        },
      },
      rowClassRules: null,
      statusBar: null,
      sideBar: null,
      domLayout: null,
      columnDefs: null,
      tableData: null,
      // Cell Renderer Components
      components: {
      },
    };
  },
  watch: {
    windowWidth(val) {
      // Toggle colummn movable
      this.toggleColumnMovable(val);
      // Toggle colummn pinning
      this.toggleColumnPinned(val);
    },
    filteredData(val) {
      if (val !== null) {
        if(this.activeFilterStatus == 'edit-requests') {
          val.forEach((x) => {
            x.cnic_promo.id = x.id;
            x.cnic_promo.end_date = x.end_date;
            x.cnic_promo.end_time = x.end_time;
            x.cnic_promo.status = x.status;
            x.cnic_promo.comments = x.comments;
          });

          var tempData = val.map((x) => {
            return x.cnic_promo;
          });
          
          this.tableData = tempData;
        } else {
          this.tableData = val;
        }
      } else {
        this.populateTableData();
      }
    },
  },
  computed: {
    windowWidth: function () {
      return this.$store.state.windowWidth;
    },
    user_role() {
      return JSON.parse(localStorage.getItem('userDetails')).role;
    },
    user_id() {
      return JSON.parse(localStorage.getItem('userDetails')).id;
    },
    status() {
      return event.node;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    yesText() {
      return 'Yes';
    },
    noText() {
      return 'No';
    },
  },
  methods: {
    setAutoHeight() {
      this.gridApi.setDomLayout('autoHeight');
      // auto height will get the grid to fill the height of the contents,
      // so the grid div should have no height set, the height is dynamic.
      document.querySelector('#autoHeightGrid').style.height = '';
    },
    openLoadingInDiv() {
      this.$vs.loading({
        container: '#div-with-loading',
        scale: 0.8,
      });
    },
    hideLoadingInDiv() {
      this.$vs.loading.close('#div-with-loading > .con-vs-loading');
    },
    populateTableData() {
      if (this.filteredData !== null) {
        this.tableData = this.filteredData;
      }
    },
    toggleColumnMovable(val) {
      if (val <= 576) {
        this.defaultColDef['suppressMovable'] = true;
      } else {
        this.defaultColDef['suppressMovable'] = false;
      }
    },
    toggleColumnPinned(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4;
        this.gridOptions.columnApi.setColumnPinned('domain', null);
      } else {
        this.gridOptions.columnApi.setColumnPinned('domain', 'left');
      }
    },
    onColumnResized() {
      this.gridApi.resetRowHeights();
    },
    sizeColumnsToFit() {
      this.gridApi.sizeColumnsToFit();
    },
    disableQueue() {
      this.rowClassRules = {
        'ag-row-disabled': 'data && (data.status == `edit pending`)',
        'ag-checkbox-disabled': 'data && (data.status == `edit pending`)',
      };
    },
    refreshPage() {
      // Reset sort
      this.gridApi.setSortModel(null);
      // Table Data AXIOS Call
      this.populateTableData();
    },
    refreshPageWithFilters() {
      // Reset filters
      this.gridApi.setFilterModel(null);
      // Reset sort
      this.gridApi.setSortModel(null);
      // Table Data AXIOS Call
      this.populateTableData();
    },
    viewAllCNICPromos() {
      this.$store.dispatch('setSwitchToTab', 'cnic');
      this.$router.push('/promos/lists');
    },
  },
  beforeMount() {
    this.disableQueue();

    // Table Data AXIOS Call
    this.populateTableData();

    // Reset movable columns on mobile
    this.toggleColumnMovable(this.windowWidth);

    (this.columnDefs = [
      {
        headerName: 'Promo Name',
        field: 'promo_name',
        filter: 'agSetColumnFilter',
        minWidth: 180,
      },
      {
        headerName: 'Type',
        field: 'type_of_reg',
        filter: 'agSetColumnFilter',
        minWidth: 100,
      },
      {
        headerName: 'TLD',
        field: 'tld.tld_name',
        filter: 'agSetColumnFilter',
        minWidth: 100,
        width: 150,
      },
      {
        headerName: 'Premium',
        field: 'premium',
        filter: 'agSetColumnFilter',
        minWidth: 150,
      },
      {
        headerName: 'Effective($)',
        field: 'effective_price_amt',
        filter: 'agTextColumnFilter',
        minWidth: 100,
      },
    ]),
    // Set Grid sidebar
    (this.sideBar = {
      toolPanels: [
        {
          id: 'columns',
          labelDefault: 'Columns',
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
          toolPanelParams: {
            suppressRowGroups: true,
            suppressValues: true,
            suppressPivots: true,
            suppressPivotMode: true,
            suppressSideButtons: true,
            suppressColumnSelectAll: true,
            suppressColumnExpandAll: true,
          },
        },
      ],
    });
  },
  mounted() {
    this.gridApi = this.gridOptions.api;

    this.setAutoHeight();

    //agigrid loader
    this.gridApi.showLoadingOverlay();

    // Resize to fit columns
    this.sizeColumnsToFit();

    // Reset pinned columns on mobile
    this.toggleColumnPinned(this.windowWidth);

    this.$root.$on('tableRefresh', () => {
      this.refreshPage();
    });
  },
  destroyed() {
    this.$store.dispatch('clearListingCount');
    this.$root.$off('tableRefresh');
  },
  beforeDestroy() {
    if (this.$refs.vsCollapseItem) {
      for (let collapseItem of this.$refs.vsCollapseItem) {
        window.removeEventListener('resize', collapseItem);
      }
    }
  },
};
</script>
